import { AdminETLTask } from '../types';
import { api } from '../../../../core/utils/apiClient';

export class AdminETLService {
  async getAllTasks(): Promise<AdminETLTask[]> {
    try {
      const response = await api.get('/api/v1/etl/tasks');
      if (response.ok) {
        const data = await response.json();
        return data.tasks || [];
      }
      return [];
    } catch (error) {
      console.error('Error fetching ETL tasks:', error);
      return [];
    }
  }

  async getTaskById(taskId: number): Promise<AdminETLTask | null> {
    try {
      const response = await api.get(`/api/v1/etl/tasks/${taskId}`);
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Error fetching ETL task:', error);
      return null;
    }
  }

  async getTaskStatistics() {
    try {
      const response = await api.get('/api/v1/etl/tasks/statistics');
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Error fetching ETL statistics:', error);
      return null;
    }
  }

  async getWorkersStatus() {
    try {
      const response = await api.get('/api/v1/etl/workers/status');
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Error fetching workers status:', error);
      return null;
    }
  }

  async retryTask(taskId: number) {
    try {
      const response = await api.post(`/api/v1/etl/documents/${taskId}/process`);
      return response.ok;
    } catch (error) {
      console.error('Error retrying task:', error);
      return false;
    }
  }
}

export const adminETLService = new AdminETLService();

